import * as React from 'react';
import { Button, Typography } from '@mui/material';
import { SectionCallToActionType } from '../../types/blocks/section-call-to-action-type';
import { SectionAppStoresBanner } from './section-app-stores-banner';
import { CallToActionButton } from '../elements/call-to-action-button';

interface SectionCallToActionProps {
  element: SectionCallToActionType;
}

export const SectionCallToAction: React.FC<SectionCallToActionProps> = ({ element }) =>
  element.AppStoresBanner ? (
    <>
      <div className="bg-paper px-4 md:px-[40px] lg:px-[88px] m-0">
        <div className="py-16 sm:py-24 md:min-h-[920px] flex flex-col justify-center max-w-[1140px] m-auto relative">
          <div className="space-y-4 md:space-y-10 max-w-[600px] relative z-10">
            <div className="flex flex-col gap-y-2">
              <Typography variant="h1" color="textPrimary">
                {element.title}
              </Typography>
              <Typography variant="s1" color="textSecondary" className="leading-6">
                {element.description}
              </Typography>
            </div>
            <SectionAppStoresBanner
              ctaButtons={element.AppStoresBanner.storesCallToActions}
              ctaClassName="max-w-[180px]"
            />
          </div>

          <img
            src="/assets/images/homepage/app-screen.svg"
            className="hidden md:block absolute top-0 translate-x-[60%] xl:translate-x-0 md:right-0"
          />
        </div>
      </div>
    </>
  ) : (
    <div className="bg-paper py-8 md:py-16 px-4 md:px-[40px] lg:px-[88px]">
      <div className="max-w-[800px] flex flex-wrap sm:flex-nowrap justify-between items-center gap-4 mx-auto">
        <Typography variant="title-mac-sans-xl">{element.title}</Typography>
        <CallToActionButton button={element.callToAction} className="flex-none" />
      </div>
    </div>
  );
